import { gql } from '@apollo/client';

import { ADDRESS_FRAGMENT } from '../fragments';

export const GET_ORGANIZATIONS_BY_USER = gql`
  query getOrganizationsByUser {
    organizationsByUser {
      id
      name
      phoneNumber
      address {
        ...addressFragment
      }
      operatesAsAgency
      isBaymaxEnabled
    }
  }
  ${ADDRESS_FRAGMENT}
`;
